import React from 'react';

import PropTypes from 'prop-types';

import { Text, Button, NavListItem, EmptyState } from 'modules/common';

function NavList({
  title,
  description,
  options,
  buttonProps,
  withButton,
  isActiveCondition,
  onClick,
  maxHeight,
}) {
  return (
    <div className="bg-primitive-white border border-default rounded">
      <div className="flex flex-col gap-ds-4 p-ds-16 border-b border-default">
        {title && (
          <Text weight="semibold" type="subheading">
            {title}
          </Text>
        )}

        {description && <Text color="muted">{description}</Text>}
      </div>

      <div
        className="overflow-y-auto"
        style={{ maxHeight: options?.length > 0 ? maxHeight : 'auto' }}
      >
        {options?.length > 0 ? (
          options?.map((item, key) => (
            <NavListItem
              // eslint-disable-next-line react/no-array-index-key
              key={key}
              label={item?.label}
              isActive={
                isActiveCondition
                  ? isActiveCondition(item, key)
                  : item?.isActive
              }
              onClick={() => onClick(item)}
            />
          ))
        ) : (
          <EmptyState />
        )}
      </div>

      {withButton && (
        <div className="p-ds-16 border-t border-default">
          <Button className="w-full" label="Button" {...buttonProps} />
        </div>
      )}
    </div>
  );
}

NavList.defaultProps = {
  options: [],
  title: '',
  description: '',
  buttonProps: {},
  withButton: true,
  isActiveCondition: false,
  onClick: () => {},
  maxHeight: 'auto',
};

NavList.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  maxHeight: PropTypes.string,
  withButton: PropTypes.bool,
  buttonProps: PropTypes.instanceOf(Object),
  isActiveCondition: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.instanceOf(Function),
  ]),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      isActive: PropTypes.bool,
    })
  ),
  onClick: PropTypes.instanceOf(Function),
};

export default NavList;
